<template>
    <div class="participant">
        <div
            v-if="isPrivatePage || isUserNotFound"
            class="stub"
            :style="stubHeight"
        >
            <div class="stub-text">
                {{ stubText }}
            </div>
        </div>
        <div v-else class="wrapper">
            <div class="header">
              <div>Участник платформы</div>
              <div class="action-buttons">
                <router-link v-if="getPrevUserLink" :to="getPrevUserLink" class="button button-blue">
                  Предыдущий
                </router-link>
                <router-link v-if="getNextUserLink" :to="getNextUserLink" class="button button-blue">
                  Следующий
                </router-link>
              </div>
            </div>
            <div class="content">
                <div class="content-left">
                    <div class="content-block-container">
                        <ParticipantProfile
                            :user="getUser"
                        />
                    </div>
                    <Folder
                        class="content-block"
                        title="Полный профиль"
                    >
                        <ParticipantFullProfile
                            :user="getUser"
                        />
                    </Folder>
                </div>
                <div class="content-right">
                    <Folder
                        class="content-block"
                        title="Проекты"
                    >
                        <ParticipantProjects
                            :items="getUserProjects"
                        />
                    </Folder>
                    <Folder
                        class="content-block"
                        title="Компетенции и навыки"
                    >
                        <ParticipantCompetences
                            :items="getUserCompetences"
                        />
                    </Folder>
                    <Folder
                        class="content-block"
                        title="Профессии"
                    >
                        <ParticipantProfessions
                            :items="getUserProfessions"
                        />
                    </Folder>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Folder from "@/components/UI/Folder";
import ParticipantProfile from '@/components/participants/ParticipantProfile';
import ParticipantFullProfile from '@/components/participants/ParticipantFullProfile';
import ParticipantProjects from '@/components/participants/ParticipantProjects';
import ParticipantCompetences from '@/components/participants/ParticipantCompetences';
import ParticipantProfessions from '@/components/participants/ParticipantProfessions';

import { mapGetters, mapActions } from 'vuex';
import gql from "graphql-tag";
import { graphQueryConstructor, lexParse } from "@/tools/graphQueryConstructor";
import qs from "qs";

const getters = [
    'isMobile',
    'contentHeight',
    'heightToFooter',
];
const usersGetters = [
    'getUser',
    'getUserAwards',
    'getUserProjects',
    'getUserCompetences',
    'getUserProfessions',
    'getChatWithUserIsPrivate',
];
const usersActions = [
    'loadUserById',
    'loadUserAwards',
    'loadUserProjects',
    'loadUserCompetences',
    'loadUserProfessions',
];

export default {
    name: "Participant",

    components: {
        Folder,
        ParticipantProfile,
        ParticipantFullProfile,
        ParticipantProjects,
        ParticipantCompetences,
        ParticipantProfessions,
    },

    data() {
      return {
        loading: false,
        userFields: [
          'id',
          'userId',
          'avatar',
          'name',
          'surname',
          'patronymic',
          'age',
          // 'dateOfBirth', Недолжно отдаваться (нужен только age)
          // 'city', // Пока не работает
          // 'address', // Не должно отдаваться (нужен только city)
          'activity',
          'about',
          'vk', 'ok', 'instagram', 'fb', 'yt', 'tiktok', 'zen', 'telegram', 'rutube', 'yappy',
          'gender',
          // 'status', // Статус черновика (не нужно в публичном профиле)
          'foreignStatusId',
          'tel',
          'email',
          // 'educationLevel',  // Неизвестное поле (видимо относится к образованию)
          // 'educationPlace', // Неизвестное поле (видимо относится к образованию)
          // 'address', // Повторение поля address
          // 'educationDuration', // Неизвестное поле (видимо относится к образованию)
          // 'specialty', // Неизвестное поле (видимо относится к образованию)
          // 'qualification', // Неизвестное поле (видимо относится к образованию)
          // 'educationDegree', // Неизвестное поле (видимо относится к образованию)
          // 'organization', // Неизвестное поле (видимо относится к карьере)
          'position',
          // 'regAddress', // Не нужен для публичного профиля
          'regEmail', // Выводится как контактный E-mail если не заполнен email
          // 'regSite', // Неизвестное поле
          // 'activityPeriod', // Неизвестное поле
          // 'responsibilities', // Неизвестное поле (видимо относится к карьере)
          'desiredArea',
          'isNoWorkExperience',
          'volunteerActivity',
          'socialActivity',
          'userCareers',
          'userEducation',
        ],
        searchString: "",
        filters: {},
        skip: 0,
        offset: 0,
      };
    },

    apollo: {
      $skipAll: true,
      users: {
        query() {
            let searchData;

            try {
                searchData = lexParse(this.searchString);
            } catch (e) {
                searchData = this.searchString;
            }

            return gql(
              graphQueryConstructor(this.filters, searchData)
            );
        },
        variables: {
          searchString: '',
          skip: 0,
        },
      },
    },

    computed: {
        ...mapGetters(getters),
        ...mapGetters('newUsers', usersGetters),
        ...mapGetters('auth', [
            'getUserRoles',
        ]),

        userId() {
            return parseInt(this.$route.params.id || '0');
        },

        isPrivatePage() {
            if(this.getUser) {
                return this.getUser.isPrivatePage;
            }
            return false;
        },

        isUserNotFound() {
            return this.getUser === null;
        },

        stubHeight() {
            const height = this.isMobile ? this.contentHeight : this.heightToFooter;
            return { 'min-height': `${ height }px` };
        },

        stubText() {
            if(this.isPrivatePage) {
                return 'Пользователь скрыл свой профиль';
            } else if(this.isUserNotFound) {
                return 'Пользователь не найден';
            }
            return '';
        },

      getPrevUserLink() {
        if (this.offset === 0) {
          return null;
        }

        let lastUserId = null;

        for (const user of (this.users && this.users.items) || []) {
          if (user.id === this.userId) {
            break;
          }
          lastUserId = user.id;
        }

        if (!lastUserId) {
          return null;
        }

        const query = { ...this.$route.query };
        query.offset = this.offset - 1;

        return this.$router.resolve({
          name: this.$route.name,
          query,
          params: { id: lastUserId } }
        ).href;
      },
      getNextUserLink() {
        let nextUserId = null;

        for (const user of (this.users && this.users.items) || []) {
          if (nextUserId === this.userId) {
            nextUserId = user.id;
            break;
          }
          nextUserId = user.id;
        }

        if (!nextUserId || nextUserId === this.userId) {
          return null;
        }

        const query = { ...this.$route.query };
        query.offset = this.offset + 1;

        return this.$router.resolve({
          name: this.$route.name,
          query,
          params: { id: nextUserId },
        }).href;
      },
    },

    watch: {
        async userId() {
            await this.initPage();

            const offset = parseInt(this.$route.query.offset || '0');
            this.offset = offset;
            this.skip = offset > 0 ? offset - 1 : 0;

            this.$apollo.queries.users.refetch({
              searchString: this.searchString,
              skip: this.skip,
            });
        },
    },

    created() {
        const hasAccess = ['ROLE_ADMIN', 'ROLE_USER_ADMIN_READ_ONLY'].some(el => this.getUserRoles.includes(el));

        if (!hasAccess) {
            this.$router.push({ name: '404' });
            return;
        }

      this.initPage();

      const routeQuery = this.$route.query;
      const queryString = Object.keys(routeQuery).map(key => `${key}=${routeQuery[key]}`).join('&');
      const queryData = qs.parse(queryString) || {};

      if (queryData.filters && Object.keys(queryData.filters).length > 0) {
        this.filters = queryData.filters;
      }

      if (queryData.search) {
        this.searchString = queryData.search;
      }

      if (queryData.offset) {
        const offset = parseInt(queryData.offset);
        this.offset = offset;
        this.skip = offset > 0 ? offset - 1 : 0;
      }

      this.$nextTick(() => {
        this.$apollo.skipAll = false;

        this.$apollo.queries.users.refetch({
          searchString: this.searchString,
          skip: this.skip,
        });
      });
    },

    methods: {
        ...mapActions('newUsers', usersActions),

        async initPage() {
            this.loading = true;
            try {
                await Promise.all([
                    this.loadUserById({ userId: this.userId, fields: this.userFields }),
                    this.loadUserProjects(this.userId),
                    this.loadUserCompetences(this.userId),
                    this.loadUserProfessions(this.userId),
                ]);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss">
@import "~@/styles/rem";

.participant {
    header {
        @include on-mobile {
            padding: mrem(11) mrem(16);

            &.folded {
                padding-bottom: mrem(11);
            }
        }

        .title {
            font-family: 'Proxima Nova', sans-serif;
            font-weight: 600;
            font-size: rem(24);
            line-height: rem(32);
            color: #4663AB;

            @include on-mobile {
                font-size: mrem(18);
                line-height: mrem(26);
            }
        }
    }
}
</style>

<style lang="scss" scoped>
@import "~@/styles/rem";

.participant {
    display: flex;
    justify-content: center;

    .wrapper {
        width: 80%;
        margin: 0 0 rem(80);

        @include on-mobile {
            width: 100%;
            margin: 0 0 mrem(8);
        }
    }

    .header {
        margin: rem(40) 0 rem(32) 0;
        font-family: 'Proxima Nova', sans-serif;
        font-weight: 600;
        font-size: rem(36);
        line-height: rem(44);
        color: #2A2626;

        display: flex;
        flex-direction: row;
        justify-content: space-between;
        gap: rem(40);

        @include on-mobile {
            margin: mrem(24) mrem(16);
            font-size: mrem(30);
            line-height: mrem(38);
            flex-direction: column;
            gap: mrem(40);
        }

        .action-buttons {
          display: flex;
          flex-direction: row;
          gap: rem(40);

          @include on-mobile {
            flex-direction: column;
            gap: mrem(40);
          }
        }
    }

    .content {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: flex-start;

        @include on-mobile {
            display: block;
        }

        &-left, &-right {
            width: rem(755);

            @include on-mobile {
                width: 100%;
            }
        }

        &-block, &-block-container {
            margin: 0 0 rem(32);
            box-shadow: 0 rem(6) rem(10) rgba(131, 134, 163, 0.12);

            @include on-mobile {
                margin: 0 0 mrem(24);
                box-shadow: 0 mrem(2) mrem(8) rgba(155, 161, 166, 0.23626);
            }

            &:last-of-type {
                margin: 0;

                @include on-mobile {
                    margin: 0 0 mrem(24);
                }
            }
        }

        &-block-container {
            padding: rem(32);
            border-radius: rem(4);
            background: #FFFFFF;

            @include on-mobile {
                padding: mrem(24) mrem(16);
            }
        }
    }

    .stub {
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
        width: 100%;
        min-height: rem(830);
        background: url("~@/assets/images/404.svg") no-repeat bottom/40rem;

        @include on-mobile {
            min-height: mrem(830);
            background-size: 90rem;
        }

        &-text {
            font-size: rem(40);
            line-height: rem(54);
            text-align: center;
            color: #8DB3C8;

            @include on-md {
                font-size: mdrem(40);
                line-height: mdrem(54);
            }

            @include on-mobile {
                font-size: mrem(24);
                line-height: mrem(36);
            }
        }
    }
}
</style>
